import { useState } from "react";
import CreateKnckoutMatchDialog from "../../../components/update-knockout-match-dialog";
import KnockOutMatch from "../../../components/knockout-match";
import { KnockOutMatches } from "../../../features/matches/matchesSlice";
import { useAppSelector } from "../../../hooks";
import { KNOCK_OUT_MATCH_TYPE, Match } from "../../../types/types";
import useWindowDimensions from "../../../hooks/useWindowDimensions";

function QuarterFinalsTeams() {
  const pulje = useAppSelector((state) => state.puljer.selectedPulje)?.id;
  const [selectedKnockoutMatch, setSelectedKnockoutMatch] = useState<keyof KnockOutMatches>();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState<Match>();
  const matches = useAppSelector((state) => state.matches.groupMatches);
  const q_1 = matches.find((match) => match.pulje.id === pulje && match.knockoutMatchId === "q_1");
  const q_2 = matches.find((match) => match.pulje.id === pulje && match.knockoutMatchId === "q_2");
  const q_3 = matches.find((match) => match.pulje.id === pulje && match.knockoutMatchId === "q_3");
  const q_4 = matches.find((match) => match.pulje.id === pulje && match.knockoutMatchId === "q_4");
  const { isDesktop } = useWindowDimensions();

  const knockOutMatchClickedHandler = (match: Match) => {
    setSelectedMatch(match);
    setSelectedKnockoutMatch(match.knockoutMatchId as any);
    setOpenDialog(true);
  };

  const closeDialogHandler = () => {
    setSelectedKnockoutMatch(undefined);
    setSelectedMatch(undefined);
    setOpenDialog(false);
  };

  return (
    <>
      <CreateKnckoutMatchDialog
        open={openDialog}
        handleClose={closeDialogHandler}
        selectedMatch={selectedMatch}
        selectedKnockoutMatchKey={selectedKnockoutMatch}
        knockOutMatchType={KNOCK_OUT_MATCH_TYPE.QUARTER_FINAL}
      />
      <div className="knockout-teams">
        <KnockOutMatch onClickCallback={(match) => isDesktop && knockOutMatchClickedHandler(match)} match={q_1} />
        <KnockOutMatch onClickCallback={(match) => isDesktop && knockOutMatchClickedHandler(match)} match={q_2} />
        <KnockOutMatch onClickCallback={(match) => isDesktop && knockOutMatchClickedHandler(match)} match={q_3} />
        <KnockOutMatch onClickCallback={(match) => isDesktop && knockOutMatchClickedHandler(match)} match={q_4} />
      </div>
    </>
  );
}

export default QuarterFinalsTeams;
